import React, { useState } from 'react';
import { mainAssets, animalAssets } from '../../services/constant';
import './main.css';
import PoliciesCard from '../../components/policiesCard';
import ManagementCard from '../../components/managementCard';
import toast, { Toaster } from 'react-hot-toast';
import { Logout } from '../../services/utils';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import MemberModal from '../../components/memberModal';

export default function MainPage() {
  const [valid, setValid] = useState('');
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [showMember, setShowMember] = useState(false);

  const userData = JSON.parse(localStorage.getItem('userData'));

  const openUser = Boolean(anchorElUser);
  const idUser = openUser ? 'simple-popover' : undefined;

  const popUpUser = (e) => {
    setAnchorElUser(e.currentTarget);
  }
  const handleCloseUser = () => {
    setAnchorElUser(null);
  };

  const addMember = () => {
    setShowMember(true);
    setAnchorElUser(null);
  }

  return (
    <div className='bg-color w--100 h--100'>
      <div className='center'>
        <div className='btn_log'>
          <button className="btn_icon bg-color" onClick={popUpUser}>
            <img src={animalAssets.ic_user} alt="" />
          </button>
          <Popover
            id={idUser}
            open={openUser}
            anchorEl={anchorElUser}
            onClose={handleCloseUser}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              '& .MuiPaper-root': {

                maxWidth: '17rem',
                width: '100%',
                border: '1px solid #fff',
                borderRadius: '1.1rem',
                boxShadow: '0px 0px 23px 0px #00000026'
              },
            }}
          >
            <Typography sx={{ padding: '1.5rem 2.0rem 1.5rem 1.9rem' }}>
              <div className="flex-colunm">
                {
                  userData?.roles[0] !== "PROVIDEROPERATOR" && (
                    <button
                      className="font-14-500 font-center common-btn"
                      onClick={() => addMember()}
                    >
                      Membros da Equipa
                    </button>
                  )
                }
                <button className="font-14-500 font-center common-btn" onClick={() => Logout()}>
                  Terminar sessão
                </button>
              </div>
            </Typography>
          </Popover>
        </div>
        <img src={animalAssets.logo} className='w-[36.2rem] h-[16.3rem] pt-[5.6rem] mx-auto' alt='Logo' />
      </div>
      <div className='main_part'>
        <div className='policies_part '>
          <PoliciesCard valid={valid} setValid={setValid} toast={toast} />
        </div>
        <div className='management_part '>
          <ManagementCard img={mainAssets.ic_1} title='GESTÃO FINANCEIRA' valid="management_card in_active" />
          <ManagementCard img={mainAssets.ic_2} title='GESTÃO CLÍNICA' valid='' />
        </div>
      </div>
      <footer className="footer">
        <img src={mainAssets.ic_3} className='icon' alt='Logo-icon'></img>
        <p className='font-16-500'>Em caso de dúvidas, poderá contactar-nos através de:</p>
        <p className='font-18-500 number'>21 020 1238</p>
        <p className='font-16-500'>  &nbsp;&nbsp;ou </p>
        <p className='font-18-500 number'>prestadores@medipet.pt</p>
      </footer>
      <Toaster position="top-right" toastOptions={{
        style: {
          fontSize: '1.5rem'
        },
      }} />
      <MemberModal showMember={showMember} setShowMember={setShowMember} />
    </div>
  );
}
